import React from 'react';
import { hideModal, } from 'actions'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import { useSelector, useDispatch, } from 'react-redux'

const AlertModal = () => {
  const userInterface = useSelector(state => state.interface);
  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(hideModal())
  }

  return (
    <Dialog
      open={userInterface.modal.isOpen}
      onClose={closeModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{userInterface.modal.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{userInterface.modal.message}</DialogContentText>
     </DialogContent>
     <DialogActions>
       {userInterface.modal.buttons.map((button, index) => (
         <Button key={index} onClick={button.callback} color="primary" className={button.className}>
           {button.label}
         </Button>
       ))}
     </DialogActions>
   </Dialog>
  )
}

export default AlertModal;
